import React, { useEffect, useState } from 'react'
import Select from "@mui/material/Select";
import MenuItem from '@mui/material/MenuItem'
import './paletteDropDown.scss'
import FormControl from '@mui/material/FormControl'
import ListItem from '@mui/material/ListItem'
import Palette from '../../../Constants/palette'

const PaletteDropDown = React.memo((props) => {
  const [color, setColor] = useState('');

  const blueShades = Palette.BLUE.colors
  const redShades = Palette.RED.colors
  const greenShades = Palette.GREEN.colors
  const grayShades = Palette.GRAY.colors
  const orangeShades = Palette.ORANGE.colors

  useEffect(() => {
    if (props.color) {
      setColor(props.color);
    }
  }, [props])

  const handleChange = (event) => {
    setColor(event.target.value);
    if (props.onChange) {
      props.onChange(event.target.value)
    }
  };

  const renderPalette = (color) => {
    let items = null
    switch (color) {
      case '5':
        items = blueShades.map((shade) => <ListItem component="div" key={shade + Math.random()} className="option" style={{backgroundColor: shade}}/>)
        break
      case '2':
        items = redShades.map((shade) =><ListItem component="div" key={shade + Math.random()} className="option" style={{backgroundColor: shade}}/>)
        break
      case '1':
        items = greenShades.map((shade) => <ListItem component="div" key={shade + Math.random()} className="option" style={{backgroundColor: shade}}/>)
        break
      case '3':
        items = grayShades.map((shade) => <ListItem component="div" key={shade + Math.random()} className="option" style={{backgroundColor: shade}}/>)
        break
      case '4':
        items = orangeShades.map((shade) => <ListItem component="div" key={shade + Math.random()} className="option" style={{backgroundColor: shade}}/>)
        break
      default:
        items = <span>Select a theme</span>
        break
    }

    return <div className="row-container">{items}</div>
  }

  return (
    <FormControl className="palette-drop-down">
      <Select
        value={color}
        variant="outlined"
        onChange={handleChange}
        displayEmpty={true}
        renderValue={value => renderPalette(value)}
      >
        <MenuItem value='1'>
          {renderPalette('1')}
        </MenuItem>
        <MenuItem value='2'>
          {renderPalette('2')}
        </MenuItem>
        <MenuItem value='3'>
          {renderPalette('3')}
        </MenuItem>
        <MenuItem value='4'>
          {renderPalette('4')}
        </MenuItem>
        <MenuItem value='5'>
          {renderPalette('5')}
        </MenuItem>
      </Select>
    </FormControl>
  );
})

export default PaletteDropDown
